export type AppointmentStatus = "Bekliyor" | "Teyit Edildi" | "Geldi" | "Gelmedi" | "İptal Etti";
export type PaymentStatus = "Ödendi" | "Eksik Ödeme" | "Açık Ödeme";
export type SourceType = "Google" | "Meta" | "WhatsApp" | "Tavsiye" | "Tekrar Müşteri" | "Çağrı";

export interface ServiceItem {
  serviceName: string;
  staff: string;
  duration: number;
  price: number;
}

export interface Appointment {
  id: string;
  customerName: string;
  customerPhone: string;
  service: string; // birincil hizmet (eski uyumluluk)
  staff: string; // birincil personel (eski uyumluluk)
  date: string;
  time: string;
  duration: number; // toplam dakika
  source: SourceType;
  notes: string;
  status: AppointmentStatus;
  paymentStatus: PaymentStatus;
  price: number; // toplam fiyat
  whatsappConfirmed: boolean;
  createdAt: string;
  packageId?: string;
  packageName?: string;
  serviceItems: ServiceItem[];
}

export function getServiceDuration(service: string): number {
  if (service.includes("90 dk")) return 90;
  if (service.includes("60 dk")) return 60;
  if (service.includes("SPA Günü Paketi")) return 240;
  if (service.includes("Cilt Bakımı + Masaj Paketi")) return 120;
  if (service.includes("Detoks SPA Paketi")) return 180;
  return 60;
}

export const appointments: Appointment[] = [
  {
    id: "ap-001",
    customerName: "Ayşe Yılmaz",
    customerPhone: "+90 532 123 4567",
    service: "Sıcak Taş Masajı (90 dk)",
    staff: "Ayşe K.",
    date: "2026-05-08",
    time: "10:00",
    duration: 90,
    source: "Google",
    notes: "Sırt ağrısı şikayeti var, hassas bölgeye dikkat",
    status: "Teyit Edildi",
    paymentStatus: "Ödendi",
    price: 1200,
    whatsappConfirmed: true,
    createdAt: "2026-05-05",
    serviceItems: [
      { serviceName: "Sıcak Taş Masajı (90 dk)", staff: "Ayşe K.", duration: 90, price: 1200 },
    ],
  },
  {
    id: "ap-002",
    customerName: "Mehmet Demir",
    customerPhone: "+90 533 987 6543",
    service: "Anti-Aging Cilt Bakımı",
    staff: "Zeynep D.",
    date: "2026-05-08",
    time: "11:30",
    duration: 60,
    source: "Tekrar Müşteri",
    notes: "Paketten 3. seansı",
    status: "Geldi",
    paymentStatus: "Ödendi",
    price: 950,
    whatsappConfirmed: true,
    createdAt: "2026-05-04",
    serviceItems: [
      { serviceName: "Anti-Aging Cilt Bakımı", staff: "Zeynep D.", duration: 60, price: 950 },
    ],
  },
  {
    id: "ap-003",
    customerName: "Elif Kaya",
    customerPhone: "+90 534 555 1122",
    service: "SPA Günü Paketi",
    staff: "Mehmet S.",
    date: "2026-05-08",
    time: "14:00",
    duration: 240,
    source: "WhatsApp",
    notes: "Hediye paketi talep etti",
    status: "Bekliyor",
    paymentStatus: "Açık Ödeme",
    price: 2500,
    whatsappConfirmed: false,
    createdAt: "2026-05-07",
    serviceItems: [
      { serviceName: "SPA Günü Paketi", staff: "Mehmet S.", duration: 240, price: 2500 },
    ],
  },
  {
    id: "ap-004",
    customerName: "Burak Şahin",
    customerPhone: "+90 535 333 7788",
    service: "Klasik Masaj (60 dk)",
    staff: "Burak T.",
    date: "2026-05-08",
    time: "15:30",
    duration: 60,
    source: "Meta",
    notes: "İlk ziyaret, tanıtım formu doldurulacak",
    status: "Teyit Edildi",
    paymentStatus: "Ödendi",
    price: 750,
    whatsappConfirmed: true,
    createdAt: "2026-05-06",
    serviceItems: [
      { serviceName: "Klasik Masaj (60 dk)", staff: "Burak T.", duration: 60, price: 750 },
    ],
  },
  {
    id: "ap-005",
    customerName: "Zeynep Arslan",
    customerPhone: "+90 536 444 9999",
    service: "Aromaterapi Masajı",
    staff: "Elif Y.",
    date: "2026-05-08",
    time: "16:45",
    duration: 60,
    source: "Tavsiye",
    notes: "Özel lavanta yağı istedi",
    status: "Geldi",
    paymentStatus: "Eksik Ödeme",
    price: 1100,
    whatsappConfirmed: true,
    createdAt: "2026-05-03",
    serviceItems: [
      { serviceName: "Aromaterapi Masajı", staff: "Elif Y.", duration: 60, price: 1100 },
    ],
  },
  {
    id: "ap-006",
    customerName: "Can Özdemir",
    customerPhone: "+90 537 666 2233",
    service: "Profesyonel Pedikür",
    staff: "Ayşe K.",
    date: "2026-05-08",
    time: "18:00",
    duration: 60,
    source: "Google",
    notes: "Ayak tırnak batığı sorunu",
    status: "Bekliyor",
    paymentStatus: "Açık Ödeme",
    price: 600,
    whatsappConfirmed: false,
    createdAt: "2026-05-07",
    serviceItems: [
      { serviceName: "Profesyonel Pedikür", staff: "Ayşe K.", duration: 60, price: 600 },
    ],
  },
  {
    id: "ap-007",
    customerName: "Selin Çelik",
    customerPhone: "+90 538 777 3344",
    service: "Cilt Bakımı + Masaj Paketi",
    staff: "Zeynep D.",
    date: "2026-05-08",
    time: "19:30",
    duration: 120,
    source: "Tekrar Müşteri",
    notes: "Paketin son seansı, yenileme teklif edilecek",
    status: "Teyit Edildi",
    paymentStatus: "Ödendi",
    price: 1800,
    whatsappConfirmed: true,
    createdAt: "2026-05-01",
    packageId: "pkg-006",
    packageName: "5 Seans Cilt + Masaj",
    serviceItems: [
      { serviceName: "Cilt Bakımı + Masaj Paketi", staff: "Zeynep D.", duration: 120, price: 1800 },
    ],
  },
  {
    id: "ap-008",
    customerName: "Ahmet Koç",
    customerPhone: "+90 539 888 5566",
    service: "Sporcu Masajı",
    staff: "Mehmet S.",
    date: "2026-05-09",
    time: "09:00",
    duration: 60,
    source: "WhatsApp",
    notes: "Koşu sonrası ağrı için",
    status: "Bekliyor",
    paymentStatus: "Açık Ödeme",
    price: 900,
    whatsappConfirmed: false,
    createdAt: "2026-05-07",
    packageId: "pkg-007",
    packageName: "10 Seans Sporcu Masajı",
    serviceItems: [
      { serviceName: "Sporcu Masajı", staff: "Mehmet S.", duration: 60, price: 900 },
    ],
  },
  {
    id: "ap-009",
    customerName: "Nur Aydın",
    customerPhone: "+90 530 999 6677",
    service: "Medikal Masaj",
    staff: "Burak T.",
    date: "2026-05-09",
    time: "10:30",
    duration: 60,
    source: "Tavsiye",
    notes: "Doktor önerisiyle geliyor",
    status: "Teyit Edildi",
    paymentStatus: "Ödendi",
    price: 1400,
    whatsappConfirmed: true,
    createdAt: "2026-05-06",
    packageId: "pkg-004",
    packageName: "12 Seans Medikal Masaj",
    serviceItems: [
      { serviceName: "Medikal Masaj", staff: "Burak T.", duration: 60, price: 1400 },
    ],
  },
  {
    id: "ap-010",
    customerName: "Ece Yıldız",
    customerPhone: "+90 531 111 8899",
    service: "Tüm Vücut Peeling",
    staff: "Elif Y.",
    date: "2026-05-09",
    time: "12:00",
    duration: 90,
    source: "Meta",
    notes: "Düğün öncesi hazırlık",
    status: "Bekliyor",
    paymentStatus: "Açık Ödeme",
    price: 1300,
    whatsappConfirmed: false,
    createdAt: "2026-05-07",
    serviceItems: [
      { serviceName: "Tüm Vücut Peeling", staff: "Elif Y.", duration: 90, price: 1300 },
    ],
  },
  {
    id: "ap-011",
    customerName: "Deniz Kara",
    customerPhone: "+90 532 222 9900",
    service: "Profesyonel Manikür",
    staff: "Ayşe K.",
    date: "2026-05-08",
    time: "09:00",
    duration: 60,
    source: "Tekrar Müşteri",
    notes: "Jel tırnak takviyesi istiyor",
    status: "Geldi",
    paymentStatus: "Ödendi",
    price: 500,
    whatsappConfirmed: true,
    createdAt: "2026-05-05",
    serviceItems: [
      { serviceName: "Profesyonel Manikür", staff: "Ayşe K.", duration: 60, price: 500 },
    ],
  },
  {
    id: "ap-012",
    customerName: "Gökhan Yılmaz",
    customerPhone: "+90 533 333 0011",
    service: "Detoks SPA Paketi",
    staff: "Mehmet S.",
    date: "2026-05-09",
    time: "14:00",
    duration: 180,
    source: "Google",
    notes: "İlk kez spa deneyimi, tur rehberliği yapılacak",
    status: "Bekliyor",
    paymentStatus: "Açık Ödeme",
    price: 2200,
    whatsappConfirmed: false,
    createdAt: "2026-05-07",
    serviceItems: [
      { serviceName: "Detoks SPA Paketi", staff: "Mehmet S.", duration: 180, price: 2200 },
    ],
  },
  {
    id: "ap-013",
    customerName: "Seda Çınar",
    customerPhone: "+90 534 444 1122",
    service: "Sıcak Yağ Masajı",
    staff: "Zeynep D.",
    date: "2026-05-08",
    time: "13:00",
    duration: 60,
    source: "WhatsApp",
    notes: "Stres rahatlatma odaklı",
    status: "Geldi",
    paymentStatus: "Ödendi",
    price: 850,
    whatsappConfirmed: true,
    createdAt: "2026-05-06",
    serviceItems: [
      { serviceName: "Sıcak Yağ Masajı", staff: "Zeynep D.", duration: 60, price: 850 },
    ],
  },
  {
    id: "ap-014",
    customerName: "Kerem Toprak",
    customerPhone: "+90 535 555 2233",
    service: "Profesyonel Pedikür + Manikür",
    staff: "Elif Y.",
    date: "2026-05-09",
    time: "16:00",
    duration: 90,
    source: "Tavsiye",
    notes: "Bayram öncesi bakım",
    status: "Teyit Edildi",
    paymentStatus: "Ödendi",
    price: 1100,
    whatsappConfirmed: true,
    createdAt: "2026-05-05",
    serviceItems: [
      { serviceName: "Profesyonel Pedikür + Manikür", staff: "Elif Y.", duration: 90, price: 1100 },
    ],
  },
  {
    id: "ap-015",
    customerName: "Hakan Mert",
    customerPhone: "+90 540 777 1122",
    service: "Finnish Sauna",
    staff: "Mehmet S.",
    date: "2026-05-08",
    time: "17:00",
    duration: 60,
    source: "Çağrı",
    notes: "Telefonla randevu aldı, özel sauna seansı talep etti",
    status: "Geldi",
    paymentStatus: "Ödendi",
    price: 400,
    whatsappConfirmed: false,
    createdAt: "2026-05-08",
    serviceItems: [
      { serviceName: "Finnish Sauna", staff: "Mehmet S.", duration: 60, price: 400 },
    ],
  },
  // ÇOKLU HİZMET ÖRNEKLERİ
  {
    id: "ap-016",
    customerName: "Melis Yıldırım",
    customerPhone: "+90 541 222 3344",
    service: "Sıcak Taş Masajı + Manikür",
    staff: "Ayşe K.",
    date: "2026-05-09",
    time: "11:00",
    duration: 150,
    source: "WhatsApp",
    notes: "Masajdan sonra manikür, 15 dk ara istiyor",
    status: "Teyit Edildi",
    paymentStatus: "Ödendi",
    price: 1700,
    whatsappConfirmed: true,
    createdAt: "2026-05-07",
    serviceItems: [
      { serviceName: "Sıcak Taş Masajı (90 dk)", staff: "Ayşe K.", duration: 90, price: 1200 },
      { serviceName: "Profesyonel Manikür", staff: "Ayşe K.", duration: 60, price: 500 },
    ],
  },
  {
    id: "ap-017",
    customerName: "Ömer Kılıç",
    customerPhone: "+90 542 333 4455",
    service: "Klasik Masaj + Pedikür",
    staff: "Elif Y.",
    date: "2026-05-09",
    time: "13:30",
    duration: 120,
    source: "Tekrar Müşteri",
    notes: "Eşiyle birlikte gelecek, eşi farklı personelde",
    status: "Bekliyor",
    paymentStatus: "Açık Ödeme",
    price: 1350,
    whatsappConfirmed: false,
    createdAt: "2026-05-08",
    serviceItems: [
      { serviceName: "Klasik Masaj (60 dk)", staff: "Elif Y.", duration: 60, price: 750 },
      { serviceName: "Profesyonel Pedikür", staff: "Burak T.", duration: 60, price: 600 },
    ],
  },
  {
    id: "ap-018",
    customerName: "Defne Aksoy",
    customerPhone: "+90 543 444 5566",
    service: "Spa Günü + Cilt Bakımı",
    staff: "Zeynep D.",
    date: "2026-05-09",
    time: "10:00",
    duration: 270,
    source: "Google",
    notes: "Kız arkadaş grubu, toplam 3 kişi",
    status: "Teyit Edildi",
    paymentStatus: "Ödendi",
    price: 3800,
    whatsappConfirmed: true,
    createdAt: "2026-05-06",
    serviceItems: [
      { serviceName: "SPA Günü Paketi", staff: "Zeynep D.", duration: 180, price: 2500 },
      { serviceName: "Anti-Aging Cilt Bakımı", staff: "Zeynep D.", duration: 90, price: 1300 },
    ],
  },
  {
    id: "ap-019",
    customerName: "Emre Demirtaş",
    customerPhone: "+90 544 555 6677",
    service: "Aromaterapi + Sauna",
    staff: "Mehmet S.",
    date: "2026-05-08",
    time: "20:00",
    duration: 105,
    source: "Tavsiye",
    notes: "Gece seansı, sauna sonrası aromaterapi",
    status: "Geldi",
    paymentStatus: "Ödendi",
    price: 1350,
    whatsappConfirmed: true,
    createdAt: "2026-05-05",
    serviceItems: [
      { serviceName: "Finnish Sauna", staff: "Mehmet S.", duration: 60, price: 400 },
      { serviceName: "Aromaterapi Masajı", staff: "Mehmet S.", duration: 75, price: 950 },
    ],
  },
  {
    id: "ap-020",
    customerName: "Ceren Güneş",
    customerPhone: "+90 545 666 7788",
    service: "Manikür + Pedikür + Peeling",
    staff: "Ayşe K.",
    date: "2026-05-09",
    time: "15:00",
    duration: 150,
    source: "Meta",
    notes: "Tam bakım paketi istiyor",
    status: "Bekliyor",
    paymentStatus: "Açık Ödeme",
    price: 1950,
    whatsappConfirmed: false,
    createdAt: "2026-05-08",
    serviceItems: [
      { serviceName: "Profesyonel Manikür", staff: "Ayşe K.", duration: 60, price: 500 },
      { serviceName: "Profesyonel Pedikür", staff: "Ayşe K.", duration: 60, price: 600 },
      { serviceName: "Tüm Vücut Peeling", staff: "Elif Y.", duration: 60, price: 850 },
    ],
  },
];

export const staffMembers = [
  "Ayşe K.",
  "Mehmet S.",
  "Zeynep D.",
  "Burak T.",
  "Elif Y.",
];

export const services = [
  "Sıcak Taş Masajı (90 dk)",
  "Anti-Aging Cilt Bakımı",
  "SPA Günü Paketi",
  "Klasik Masaj (60 dk)",
  "Aromaterapi Masajı",
  "Profesyonel Pedikür",
  "Cilt Bakımı + Masaj Paketi",
  "Sporcu Masajı",
  "Medikal Masaj",
  "Tüm Vücut Peeling",
  "Profesyonel Manikür",
  "Detoks SPA Paketi",
  "Sıcak Yağ Masajı",
  "Profesyonel Pedikür + Manikür",
  "Finnish Sauna",
  "Kese Köpük",
  "Buhar Odası",
  "Tuz Odası (Haloterapi)",
  "Kese Köpük + Masaj",
];